import _ from 'lodash';
import moment from 'moment-timezone';

let formatTimeSeriesMentions = (dataPayload) => {
    let xsSet = new Set()
    const {data,groupBy} = dataPayload
    data.forEach(tpc => {
        tpc.data.forEach(subtpc => {
            subtpc.data &&
            subtpc.data.aggregations.volume_of_conversation.buckets.forEach(bucket => {
                xsSet.add(bucket.key)
            })
        })
    }, this);
    let xs = [];
    xsSet.forEach(elem => xs.push(elem));
    xs.sort();
    let timeStamps = new Array(xs.length).fill(0)
    let topics = []
    data.forEach(tpc => {
        let topicTree = getTopicsTree(JSON.parse(localStorage.getItem('meta')).topics);
        let current_tpc = topicTree.find(topic => topic.topic_id == tpc.input.topic_id);

        if (groupBy==="topic") {
            let topic = { id: tpc.input.topic_id, name: tpc.input.name, values: new Array(xs.length).fill(0), topicType: "topic" }
            tpc.data.forEach(subtpc => {
                subtpc.data &&
                subtpc.data.aggregations.volume_of_conversation.buckets.forEach(bucket => {
                    let timeIndex = xs.indexOf(bucket.key)
                    timeStamps[timeIndex] = bucket.key_as_string
                    topic.values[timeIndex] += bucket.doc_count
                })
            })
            topics.push(topic)
        } else {
            tpc.data.forEach((subtpc, index) => {
                const sbt = tpc.input.subtopicNames.find((s) => s.id == subtpc.sub_topic_id)
                let topic;
                if(sbt){
                    topic = { id: subtpc.sub_topic_id, name: sbt.name, values: new Array(xs.length).fill(0), topicType: "subtopic" };
                }
                else{
                    topic = {
                        id: subtpc.sub_topic_id,
                        name: subtpc.sub_topic_id,
                        values: new Array(xs.length).fill(0),
                        topicType: "subtopicGroup",
                        groupIds: subtpc.group_subtopic_ids,
                    };
                }
                subtpc.data && subtpc.data.aggregations.volume_of_conversation.buckets.forEach(bucket => {
                    let timeIndex = xs.indexOf(bucket.key)
                    timeStamps[timeIndex] = bucket.key_as_string
                    topic.values[timeIndex] += bucket.doc_count
                })
                topics.push(topic)
            })
        }
    });
    // console.log(topics)
    return {
        name: 'all',
        timeStamps,
        res: topics
    }
}

let formatVOCData = (data) => {
    const { topics } = JSON.parse(localStorage.getItem('meta'));
    let ret = []
    data.data.share_of_voice_widget.share_of_voice_section.dataSet.forEach(tpc => {
        let topic = {
            name: topics.find(item => item.topic_id === tpc.topic_id).topic_name,
            id: tpc.topic_id,
            value: tpc.total,
            subtopics: []
        }
        tpc.subTopics.forEach(subtpc => {
            const subTopic = topics.find(item => item.subtopic_id === subtpc.sub_topic_id)
            let subtopic
            if(subTopic) {
                subtopic = {
                    id: subtpc.sub_topic_id,
                    name: subTopic.subtopic_name,
                    value: subtpc.total
                }
            }
            else{
                subtopic = {
                    id: subtpc.sub_topic_id,
                    name: subtpc.sub_topic_id,
                    value: subtpc.total,
                    groupIds : subtpc.group_subtopic_ids
                }

            }
            topic.subtopics.push(subtopic)
        }, this)
        ret.push(topic)
    })
    ret.push({ total_unique_data: data.data.share_of_voice_widget.share_of_voice_section.overAllUniqueData });
    return ret
}

let formatCountrySentimentsBreakup = (data) => {
    let formatted = {
        countries: [],
        negative: [],
        positive: [],
        neutral: []
    };
    data.aggregations['country-sentiments-breakup'].buckets.forEach(country => {
        formatted.countries.push(country.key);
        let t = country["sentiment_group"].group1.group2.buckets.find(x => x.key === 'positive')
        const positive = t ? t.doc_count : 0
        t = country["sentiment_group"].group1.group2.buckets.find(x => x.key === 'negative')
        const negative = t ? t.doc_count : 0
        t = country["sentiment_group"].group1.group2.buckets.find(x => x.key === 'neutral')
        const neutral = t ? t.doc_count : 0
        formatted.positive.push({ y: parseFloat(((positive / country["sentiment_group"].group1.doc_count) * 100).toFixed(2)), val: positive });
        formatted.negative.push({ y: parseFloat(((negative / country["sentiment_group"].group1.doc_count) * 100).toFixed(2)), val: negative });
        formatted.neutral.push({ y: parseFloat(((neutral / country["sentiment_group"].group1.doc_count) * 100).toFixed(2)), val: neutral });
    })
    return formatted;
}

// Convert filter JSON to URLSearchParams
let getPostFeedParamsFromFilters = (filters, widgetName, orderBy, passed_post_types) => {
    const { topics, countries, platforms, influencers, themes, languages } = JSON.parse(localStorage.getItem('meta'));
    const collections = JSON.parse(localStorage.getItem("collections"))
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });

    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }
    
    let x = { ...filters };
    if (filters.hasOwnProperty('influencers')) {
        x.influencer_types = filters.influencers
        delete x.influencers
    }
    if (filters.hasOwnProperty('themes')) {
        x.theme_ids = filters.themes
        delete x.themes
    }
    delete x.publications
    let temp = null;
    let params = `data=1&order=desc`;
    if(widgetName === "topPosts") params += '&orderBy=impact_value';
    else params += `&orderBy=${orderBy ? orderBy : 'post.published_date'}`;
    const feedData = JSON.parse(sessionStorage.getItem("feedData"));
    // let campaign;

    let today = moment.utc().tz(user_timezone_name);
    let start_date = moment.utc().tz(user_timezone_name);
    let end_date = moment.utc().tz(user_timezone_name);

    switch (x.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(x.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(x.end_date)
            break;
        case "entire":
            start_date = campaign ? moment(campaign.campaign_start_date).tz(user_timezone_name) : null;
            today = campaign ? (moment(campaign.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign.campaign_end_date).tz(user_timezone_name) : null;
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd');
            break
    }

    if (x.duration === "7" || x.duration === "1M" || x.duration === "3M" || x.duration === "6M" || x.duration === "12M" || x.duration === "entire") {
        params += "&start_date=" + moment(start_date).format("YYYY-MM-DDT00:00:00");
        params += "&end_date=" + moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        params += "&start_date=" + moment(start_date).format("YYYY-MM-DDTHH:mm:ss");
        params += "&end_date=" + moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    let post_types = passed_post_types ? passed_post_types.split(",").map(p => +p) : [0, 1, 3, 4, 5];

    for (let key in x) {
        temp = "";
        if (x.hasOwnProperty(key) && key !== "duration" && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === "topics" && key !== "subtopics") {
                if (x["subtopics"] && x["subtopics"].length === 0 && x["topics"] && x["topics"].length === 0) {
                    // Do nothing, placeholder case.
                } else if (x["topics"][0] === "ALL") {
                    temp = topics.map((item) => item.subtopic_id);
                    params += "&boolean=" + temp.join(",");
                } else {
                    temp = x["topics"] && x["topics"].length > 0 ? topics.filter((item) => x["topics"].includes(item.topic_id)) : [];
                    temp = temp.map((item) => item.subtopic_id);

                    if (x["subtopics"] && x["subtopics"].length > 0) temp = temp.concat(x["subtopics"].join(","));

                    params += "&boolean=" + temp;
                }
            } else if (key === "sentiment") {
                if (x["sentiment"][0] !== "selectAll") {
                    params += "&sentiment=" + x["sentiment"].join(",");
                }
            } else if (Array.isArray(x[key])) {
                // For retweets
                if (key === "platform") {
                    if (x[key][0] === "selectAll") {
                        // post_types.push(2);
                    }
                    if (x[key].includes("twitter_retweets")) {
                        x[key] = x[key].filter((item) => item !== "twitter_retweets");
                        x[key].push("6ce32a97-a789-11e4-a34f-74867a1157ba");
                        // Remove duplicates, if any.
                        x[key] = _.union(x[key]);
                        
                        if(!post_types.includes(2) &&  !post_types.every((val, index) => val === [0,3,4][index])) post_types.push(2);
                    }
                    else{               
                        if(post_types.includes(2)) post_types =  post_types.filter(p=>p!==2)
                    }
                }
                if (key !== "topics" && key !== "subtopics" && key !== "sentiment") {
                    if (x[key].length !== 0) {
                        if (x[key][0] === "selectAll") {
                            if (key !== "location") {
                                switch (key) {
                                    case "platform":
                                        if (platforms) temp = platforms.map((item) => item.id);
                                        break;
                                    case "influencer_types":
                                        if (influencers) temp = influencers.map((item) => item.name);
                                        break;
                                    case "theme_ids":
                                        if (themes) {
                                            const view = sessionStorage.getItem("view") === "view1" ? "campaign" : "brand";
                                            temp = themes.filter((item) => item.view === view).map((item) => item.value);
                                            temp = temp.filter((t) => t.indexOf("themeHeading") < 0);
                                        }
                                        break;
                                    case "language":
                                        if (languages) temp = languages.map((item) => item.id);
                                        break;
                                    case "synced_collection_id":
                                        if (collections) temp = collections.map((item) => item.id);
                                        break;
                                    default:
                                        break;
                                }
                            } else if (key === "location") {
                                if (countries) temp = countries.map((item) => item.id);
                            }
                        } else {
                            if (key === "theme_ids") temp = x[key].filter((t) => t.indexOf("themeHeading") < 0).join(",");
                            else temp = x[key].join(",");
                        }
                    } else {
                        if (key !== "location") {
                            switch (key) {
                                case "platform":
                                    if (platforms) temp = platforms.map((item) => item.id);
                                    break;
                                default:
                                    break;
                            }
                        } else if (key === "location") {
                            if (countries) temp = countries.map((item) => item.id);
                        }
                    }
                    params += "&" + key + "=" + temp;
                }
            } else if (!Array.isArray(x[key])) {
                if (key !== "topics" && key !== "subtopics" && x[key] !== "all") {
                    params += "&" + key + "=" + x[key];
                }
            }
        }
    }

    if(post_types) params += '&post_type=' + post_types.join(',');
    if(!x.hasOwnProperty("location")) params += '&location=' + countries.map(item => item.id);
    if(!x.hasOwnProperty("platform")) params += "&platform=" + platforms.map(item => item.id);
    return params;
}

// Convert filter JSON to URLSearchParams
let getParamsFromFilters = (filters, widgetName, orderBy, passed_post_types) => {
    const { topics, countries, platforms, influencers, themes, languages } = JSON.parse(localStorage.getItem('meta'));
    const collections = JSON.parse(localStorage.getItem("collections"))
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });

    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }

    let x = { ...filters };
    if (filters.hasOwnProperty('influencers')) {
        x.influencer_types = filters.influencers
        delete x.influencers
    }
    if (filters.hasOwnProperty('themes')) {
        x.theme_ids = filters.themes
        delete x.themes
    }
    delete x.publications
    let temp = null;
    let params = `data=1&order=desc`;
    if (widgetName === "topPosts") params += '&orderBy=impact_value';
    else params += `&orderBy=${orderBy ? orderBy : 'post.published_date'}`;

    let today = moment.utc().tz(user_timezone_name);
    let start_date = moment.utc().tz(user_timezone_name);

    switch (x.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(x.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(x.end_date)
            break;
        case "entire":
            start_date = moment(campaign.campaign_start_date).tz(user_timezone_name);
            today = (moment(campaign.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign.campaign_end_date).tz(user_timezone_name);
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd');
            break
    }

    if (x.duration === "7" || x.duration === "1M" || x.duration === "3M" || x.duration === "6M" || x.duration === "12M") {
        params += "&start_date=" + moment(start_date).format("YYYY-MM-DDT00:00:00");
        params += "&end_date=" + moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        params += "&start_date=" + moment(start_date).format("YYYY-MM-DDTHH:mm:ss");
        params += "&end_date=" + moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    for (let key in x) {
        temp = '';
        if (x.hasOwnProperty(key) && key !== "duration" && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === 'topics' && key !== 'subtopics') {
                if (x['subtopics'] && x['subtopics'].length === 0 && x['topics'] && x['topics'].length === 0) {
                    // Do nothing, placeholder case.
                } else if (x['topics'][0] === 'ALL') {
                    temp = topics.map(item => item.subtopic_id);
                    params += '&boolean=' + temp.join(',');
                }
                else {
                    temp = x['topics'] && x['topics'].length > 0 ? topics.filter(item => x['topics'].includes(item.topic_id)) : [];
                    temp = temp.map(item => item.subtopic_id);

                    if (x['subtopics'] && x['subtopics'].length > 0)
                        temp = temp.concat(x['subtopics'].join(','));

                    params += '&boolean=' + temp;
                }
            } else if (key === 'sentiment') {
                if (x['sentiment'][0] !== 'selectAll') {
                    params += '&sentiment=' + x['sentiment'].join(',');
                }
            } else if (Array.isArray(x[key])) {
                if (key !== 'topics' && key !== 'subtopics' && key !== 'sentiment') {
                    if (x[key].length !== 0) {
                        if (x[key][0] === 'selectAll') {
                            if (key !== 'location') {
                                switch (key) {
                                    case 'platform':
                                        if (platforms)
                                            temp = platforms.map(item => item.id);
                                        break;
                                    case 'influencer_types':
                                        if (influencers)
                                            temp = influencers.map(item => item.name)
                                        break;
                                    case 'theme_ids':
                                        if (themes) {
                                            const view = sessionStorage.getItem("view") === "view1" ? "campaign" : "brand"
                                            temp = themes.filter(item => item.view === view).map(item => item.value)
                                            temp = temp.filter(t => t.indexOf("themeHeading") < 0)
                                        }
                                        break;
                                    case 'language':
                                        if (languages)
                                            temp = languages.map(item => item.id)
                                        break;
                                    case 'synced_collection_id':
                                        if (collections)
                                            temp = collections.map(item => item.id)
                                        break;
                                    default:
                                        break;
                                }
                            } else if (key === 'location') {
                                if (countries)
                                    temp = countries.map(item => item.id);
                            }
                        } else {
                            if (key === "theme_ids") temp = x[key].filter(t => t.indexOf("themeHeading") < 0).join(",")
                            else temp = x[key].join(',');
                        }
                    } else {
                        if (key !== 'location') {
                            switch (key) {
                                case 'platform':
                                    if (platforms)
                                        temp = platforms.map(item => item.id);
                                    break;
                                default:
                                    break;
                            }
                        } else if (key === 'location') {
                            if (countries)
                                temp = countries.map(item => item.id);
                        }
                    }
                    params += '&' + key + '=' + temp;
                }
            } else if (!Array.isArray(x[key])) {
                if (key !== 'topics' && key !== 'subtopics' && x[key] !== 'all') {
                    params += '&' + key + '=' + x[key];
                }
            }
        }

    }
    let post_types = passed_post_types ? passed_post_types.split(",").map(p => +p) : [0, 1, 2, 3, 4];
    params += '&post_type=' + post_types.join(',');
    if(!x.hasOwnProperty("location")) params += '&location=' + countries.map(item => item.id);
    if(!x.hasOwnProperty("platform")) params += '&platform=' + platforms.map(item => item.id);
    return params;
}

let getTopicsTree = (alltopics) => {
    let tree = [];
    let topics = [];
    alltopics.forEach(e => {
        if (topics.indexOf(e.topic_id) === -1) {
            topics.push(e.topic_id);
        }
    });
    if(topics) {
    topics.forEach(topicid => {
        let subtopics = alltopics.filter(sbt => sbt.topic_id === topicid);
        tree.push({
            topic_id: topicid,
            topic_name: subtopics[0].topic_name,
            campaign_start_date: subtopics[0].campaign_start_date,
            campaign_end_date: subtopics[0].campaign_end_date,
            subtopics
        });
    });
    }
    return tree;
}

// Convert filter JSON to URLSearchParams
let getSK2PostContainerParams = (filters, interval, orderBy, passed_post_types) => {
    const { topics, countries, platforms, influencers, themes, languages } = JSON.parse(localStorage.getItem('meta'));
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });
    // console.log('filters',filters)
    // console.log('campaign',campaign)
    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }

    let x = removeDeletedSavedTopicsSubTopics(filters);
    let temp = null;
    let params = {
        start_date: null,
        end_date: null,
        location_ids: [],
        platform_ids: [],
        topic_data: [],
        langauge_ids: [],
        sentiments: [],
        entity_boolean: '',
        theme_ids: [],
        orderBy: orderBy ? orderBy : 'post.published_date',
        influencer_types: [],
        interval: interval,
        enable_compare: 1,
        post_types: [0,1,3,4,5],
        groupBy: 'topic'
    };

    if(filters.should_location_language_search_with_or) params.should_location_language_search_with_or = true

    // Logic to get duration
    let today = moment.utc().tz(user_timezone_name);
    let start_date = moment.utc().tz(user_timezone_name);

    switch (x.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(x.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(x.end_date)
            break;
        case "entire":
            start_date = campaign ? moment(campaign.campaign_start_date).tz(user_timezone_name) : null;
            today = campaign ? ((moment(campaign.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign.campaign_end_date)).tz(user_timezone_name) : null;
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd');
            break
    }

    if (x.duration === "7" || x.duration === "1M" || x.duration === "3M" || x.duration === "6M" || x.duration === "12M") {
        params.start_date = moment(start_date).format("YYYY-MM-DDT00:00:00");
        params.end_date = moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        params.start_date = moment(start_date).format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    // Subtopic/Topic Grouping
    if (x['subtopics'] && x['subtopics'].length > 0) {
        params.groupBy = 'subtopic';
    }

    for (let key in x) {
        temp = []
        if (x.hasOwnProperty(key) && key !== "duration" && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === 'topics' && key !== 'subtopics') {
                if (x["topics"][0] === "ALL" || (x["subtopics"] && x["subtopics"].length === 0 && x["topics"] && x["topics"].length === 0)) {
                    // If no topic/subtopic is selected, send all.
                    // let topicTree = getTopicsTree(topics);
                    // if (sessionStorage.getItem("view") === "view1") {
                    //     const allTopicIds = topicTree.map((t) => t.topic_id);
                    //     const allTopicsFiltered = getDynamicTopics({
                    //         duration: x.duration,
                    //         start_date: x.start_date,
                    //         end_date: x.end_date,
                    //         rollingDate: x.rollingDate,
                    //         topics: allTopicIds,
                    //         subtopics: [],
                    //     }).topics;
                    //     topicTree = topicTree.filter((t) => allTopicsFiltered.includes(t.topic_id));
                    // }
                    // topicTree.forEach((tpc) => {
                    //     let obj = {
                    //         topic_id: tpc.topic_id,
                    //         subtopic_ids: tpc.subtopics.map((sbt) => sbt.subtopic_id),
                    //     };
                    //     params.topic_data.push(obj);
                    // });
                } else {
                    let topicTree = getTopicsTree(topics);
                    topicTree.forEach(tpc => {
                        let subtopicIds = tpc.subtopics.map(sbt => sbt.subtopic_id);
                        if (x['topics'].includes(tpc.topic_id)) {
                            let obj = {
                                topic_id: tpc.topic_id,
                                subtopic_ids: tpc.subtopics.map(sbt => sbt.subtopic_id)
                            }
                            params.topic_data.push(obj);
                        }
                        // For subtopics
                        x['subtopics'].forEach(sbt => {
                            if (subtopicIds.includes(sbt)) {
                                // Already exists
                                if (params.topic_data.find(item => item.topic_id === tpc.topic_id)) {
                                    let temp = params.topic_data.find(item => item.topic_id === tpc.topic_id);
                                    temp.subtopic_ids.push(sbt);
                                } else {
                                    let obj = {
                                        topic_id: tpc.topic_id,
                                        subtopic_ids: [sbt]
                                    }
                                    params.topic_data.push(obj);
                                }
                            }
                        })
                    })
                }
            } else if (key === 'sentiment') {
                if (x['sentiment'][0] !== 'selectAll') {
                    params.sentiments = x['sentiment']
                }
                else params.sentiments = ['positive', 'negative', 'neutral']
            } else if (Array.isArray(x[key])) {
                // For retweets
                if (key === 'platform') {
                     //params.post_types.push(0, 1, 3, 4);
                    if (x[key][0] === "selectAll") { params.post_types.push(2); }
                    if (x[key].includes("twitter_retweets")) {
                        // params.post_types.push(2);
                        // if (x[key].length === 1) params.post_types = [2];
                        x[key] = x[key].filter(item => item !== "twitter_retweets");
                        x[key].push("6ce32a97-a789-11e4-a34f-74867a1157ba");
                        // Remove duplicates, if any.
                        x[key] = _.union(x[key]);
                    }
                }
                if (key !== 'topics' && key !== 'subtopics' && key !== 'sentiment') {
                    if (x[key].length !== 0) {
                        if (x[key][0] === 'selectAll') {
                            if (key !== 'location') {
                                switch (key) {
                                    case 'platform':
                                        if (platforms)
                                            temp = platforms.map(item => item.id);
                                        break;
                                    case 'influencers':
                                        if (influencers)
                                            temp = influencers.map(item => item.name)
                                        break;
                                    case 'themes':
                                        if (themes)
                                            temp = themes.map(item => item.subtopic_id)
                                        break;
                                    case 'language':
                                        if (languages)
                                            temp = languages.map(item => item.id)
                                        break;
                                    default:
                                        break;
                                }
                            } else if (key === 'location') {
                                if (countries)
                                    temp = countries.map(item => item.id);
                            }
                            temp = temp.filter(item => item !== 'selectAll');
                        } else {
                            temp = x[key];
                        }
                    } else {
                        if (key !== 'location') {
                            switch (key) {
                                case 'platform':
                                    if (platforms)
                                        temp = platforms.map(item => item.id);
                                    break;
                                default:
                                    break;
                            }
                        }
                        temp = temp.filter(item => item !== 'selectAll');
                    }
                    if (key === 'publications') params.publications = x['publications']
                    if (key === 'location') {
                        params.location_ids = temp;
                    } else if (key === 'platform') {
                        params.platform_ids = temp;
                    } else if (key === 'themes') {
                        params.theme_ids = temp;
                    } else if (key === 'influencers') {
                        params.influencer_types = temp;
                    } else if (key === 'language') {
                        params.langauge_ids = temp;
                    }
                }
            }
        }
    }
    //let post_types = passed_post_types ? passed_post_types.split(",").map(p => +p) : [0, 1, 3, 4];
    //params.post_types = post_types;
    if (!x.hasOwnProperty("location")) params.location_ids = countries.map(item => item.id);
    if (!x.hasOwnProperty("platform")) params.platform_ids = platforms.map(item => item.id);
    return params;
}

const getDynamicTopics = (filters, dur, stDate, endDate, rolling) => {
    const company = JSON.parse(localStorage.getItem("meta")).company.company_identifier
    if(company!=="sk2pg") return filters

    let topics = JSON.parse(localStorage.getItem("meta")).topics.filter((tp) => tp.view_name && tp.view_name === "campaign");
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });

    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }

    const duration = filters.duration || dur;
    let start_date, end_date;
    if (duration === "custom") {
        start_date = filters.start_date || stDate;
        end_date = filters.end_date || endDate;
        let rollingDate = filters.rollingDate || rolling;
        if (rollingDate) end_date = moment().subtract(1, "d");
    } else {
        start_date = moment();
        switch (duration) {
            case "24HRS":
                start_date = moment(start_date).subtract(24, "h");
                break;
            case "1":
                start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
                break;
            case "1M":
                start_date = moment(start_date).subtract(30 - 1, "d");
                break;
            case "3M":
                start_date = moment(start_date).subtract(90 - 1, "d");
                break;
            case "6M":
                start_date = moment(start_date).subtract(180 - 1, "d");
                break;
            case "12M":
                start_date = moment(start_date).subtract(360 - 1, "d");
                break;
            case "entire":
                start_date = campaign ? moment(campaign.campaign_start_date) : null;
                // today = moment(campaign.campaign_end_date);
                break;
            case "7":
            default:
                start_date = moment(start_date).subtract(duration - 1, "d");
                break;
        }
        end_date = moment();
    }
    start_date = moment(start_date).format("YYYY-MM-DD");
    end_date = moment(end_date).format("YYYY-MM-DD");
    let topicsList = [],
        subtopics = [];
    if (filters.topics)
        topicsList = filters.topics.filter((topic) => {
            let t = topics.filter((tp) => tp.topic_id === topic);
            if (t.length > 0) {
                t = t[0];
                const campaign_start_date = moment(t.campaign_start_date).format("YYYY-MM-DD");
                let campaign_end_date = moment(t.campaign_end_date).format("YYYY-MM-DD");
                if (campaign_end_date === "Invalid date") campaign_end_date = moment().format("YYYY-MM-DD");
                if (
                    (moment(start_date).diff(moment(campaign_start_date)) <= 0 && moment(end_date).diff(moment(campaign_start_date)) >= 0) ||
                    (moment(campaign_end_date).diff(moment(start_date)) >= 0 && moment(campaign_end_date).diff(moment(end_date)) <= 0) ||
                    (moment(campaign_start_date).diff(moment(start_date)) <= 0 && moment(campaign_end_date).diff(moment(end_date)) >= 0) ||
                    (moment(campaign_start_date).diff(moment(start_date)) >= 0 && moment(campaign_end_date).diff(moment(end_date)) <= 0)
                )
                    return true;
                else return false;
            } else return false;
        });

    if (filters.subtopics)
        subtopics = filters.subtopics.filter((subtopic) => {
            let t = topics.filter((tp) => tp.subtopic_id === subtopic);
            if (t.length > 0) {
                t = t[0];
                const campaign_start_date = moment(t.campaign_start_date).format("YYYY-MM-DD");
                let campaign_end_date = moment(t.campaign_end_date).format("YYYY-MM-DD");
                if (campaign_end_date === "Invalid date") campaign_end_date = moment().format("YYYY-MM-DD");
                if (
                    (moment(start_date).diff(moment(campaign_start_date)) <= 0 && moment(end_date).diff(moment(campaign_start_date)) >= 0) ||
                    (moment(campaign_end_date).diff(moment(start_date)) >= 0 && moment(campaign_end_date).diff(moment(end_date)) <= 0) ||
                    (moment(campaign_start_date).diff(moment(start_date)) <= 0 && moment(campaign_end_date).diff(moment(end_date)) >= 0) ||
                    (moment(campaign_start_date).diff(moment(start_date)) >= 0 && moment(campaign_end_date).diff(moment(end_date)) <= 0)
                )
                    return true;
                else return false;
            } else return false;
        });

    let obj = { ...filters };
    obj.topics = topicsList;
    obj.subtopics = subtopics;
    return obj;
}

const getDynamicThemes = (filters, widgetName) => {
    let { topics, themes, company } = JSON.parse(localStorage.getItem("meta"));
    if(company.company_identifier!=="sk2pg") return filters
    let topicsSelected = [...filters.topics];
    let subTopicsSelected = [...filters.subtopics];
    let allThemesFromFilters = filters.themes;
    let themesSelected = []
    let allThemesForSelectedTopics = [];
    subTopicsSelected.map((s) => {
        topicsSelected.push(topics.find((t) => t.subtopic_id === s).topic_id);
    });
    // console.log('topicsSelected...',topicsSelected)
    themes.map((t) => {
        if (t.topics)
            Object.keys(t.topics).forEach((tp) => {
                if (topicsSelected.includes(tp)) {
                    if (
                        t.value.indexOf("themeHeading") < 0 &&
                        (t.topics[tp].selected)
                    )
                        allThemesForSelectedTopics.push(t.value);
                    if (allThemesFromFilters.includes(t.value)) themesSelected.push(t.value);
                    return;
                }
            });
    });

    if(themesSelected.length===0 && widgetName === "themesSOV") themesSelected = allThemesForSelectedTopics

    return { ...filters, themes: allThemesForSelectedTopics };
}

// Convert filter JSON to URLSearchParams
let getSK2ParamsFromFilters = (filters, interval, orderBy, post_types, widgetName, chart_type, sentiments) => {
    const { topics, countries, platforms, influencers, themes, languages, treeThemes } = JSON.parse(localStorage.getItem('meta'));
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let sentimentArr = [];
    if(widgetName === "themes") sentimentArr = sentiments;
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });

    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }


    let x = removeDeletedSavedTopicsSubTopics(filters);
    let temp = null;
    let params = {
        start_date: null,
        end_date: null,
        location_ids: [],
        platform_ids: [],
        topic_data: [],
        langauge_ids: [],
        sentiments: sentimentArr,
        entity_boolean: '',
        theme_ids: [],
        orderBy: orderBy ? orderBy : 'post.published_date',
        influencer_types: [],
        interval: interval,
        enable_compare: 1,
        post_types: [],
        groupBy: 'topic',
        chart_type:chart_type
    };

    if(filters.should_location_language_search_with_or) params.should_location_language_search_with_or = true

    let group_info = {}

    // Logic to get duration
    let today = moment.utc().tz(user_timezone_name);
    let start_date = moment.utc().tz(user_timezone_name);

    switch (x.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(x.start_date)
            today = filters.rollingDate ? moment(today).subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(x.end_date)
            break;
        case "entire":
            start_date = moment(campaign?.campaign_start_date).tz(user_timezone_name);
            today = (moment(campaign?.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign?.campaign_end_date).tz(user_timezone_name);
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd');
            break
    }

    if (x.duration === "7" || x.duration === "1M" || x.duration === "3M" || x.duration === "6M" || x.duration === "12M" ) {
        params.start_date = moment(start_date).format("YYYY-MM-DDT00:00:00");
        params.end_date = moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        params.start_date = moment(start_date).format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    // Subtopic/Topic Grouping
    if (x['subtopics'] && x['subtopics'].length > 0) {
        params.groupBy = 'subtopic';
    }

    for (let key in x) {
        temp = []
        if (x.hasOwnProperty(key) && key !== "duration" && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === 'topics' && key !== 'subtopics') {
                if (x["topics"][0] === "ALL" || (x["subtopics"] && x["subtopics"].length === 0 && x["topics"] && x["topics"].length === 0)) {
                    // If no topic/subtopic is selected, send all.
                    // let topicTree = getTopicsTree(topics);
                    // if (sessionStorage.getItem("view") === "view1") {
                    //     const allTopicIds = topicTree.map((t) => t.topic_id);
                    //     const allTopicsFiltered = getDynamicTopics({
                    //         duration: x.duration,
                    //         start_date: x.start_date,
                    //         end_date: x.end_date,
                    //         rollingDate: x.rollingDate,
                    //         topics: allTopicIds,
                    //         subtopics: [],
                    //     }).topics;
                    //     topicTree = topicTree.filter((t) => allTopicsFiltered.includes(t.topic_id));
                    // }
                    // topicTree.forEach((tpc) => {
                    //     let obj = {
                    //         topic_id: tpc.topic_id,
                    //         subtopic_ids: tpc.subtopics.map((sbt) => sbt.subtopic_id),
                    //     };
                    //     params.topic_data.push(obj);
                    // });
                } else {
                    let topicTree = getTopicsTree(topics);
                    topicTree.forEach((tpc) => {
                        let subtopicIds = tpc.subtopics.map((sbt) => sbt.subtopic_id);
                        if (x["topics"].includes(tpc.topic_id)) {
                            let obj = {
                                topic_id: tpc.topic_id,
                                subtopic_ids: tpc.subtopics.map((sbt) => sbt.subtopic_id),
                            };
                            params.topic_data.push(obj);
                        }
                        // For subtopics
                        x["subtopics"].forEach((sbt) => {
                            if (subtopicIds.includes(sbt)) {
                                // Already exists
                                if (params.topic_data.find((item) => item.topic_id === tpc.topic_id)) {
                                    let temp = params.topic_data.find((item) => item.topic_id === tpc.topic_id);
                                    temp.subtopic_ids.push(sbt);
                                } else {
                                    let obj = {
                                        topic_id: tpc.topic_id,
                                        subtopic_ids: [sbt],
                                    };
                                    params.topic_data.push(obj);
                                }
                                let subTopicData = tpc.subtopics.filter(s=>s.subtopic_id===sbt)
                                if(subTopicData && subTopicData.length && subTopicData[0].subtopic_group_name){
                                    if (!group_info[subTopicData[0].subtopic_group_name]) group_info[subTopicData[0].subtopic_group_name] = [sbt];
                                    else group_info[subTopicData[0].subtopic_group_name].push(sbt);
                                }
                            }
                        });
                    });
                }
            } else if (key === 'sentiment') {
                if (x['sentiment'][0] !== 'selectAll') {
                    params.sentiments = x['sentiment']
                }
                else params.sentiments = ['positive', 'negative', 'neutral']
            } else if (Array.isArray(x[key])) {
                // For retweets
                if (key === 'platform') {
                    if (post_types) params.post_types.push(0, 1, 3, 4);
                    if (x[key][0] === "selectAll") { if (post_types) params.post_types.push(2); }
                    else if (x[key].includes("twitter_retweets")) {
                        if (post_types) params.post_types.push(2);
                        // if (x[key].length === 1) params.post_types = [2];
                        x[key] = x[key].filter(item => item !== "twitter_retweets");
                        x[key].push("6ce32a97-a789-11e4-a34f-74867a1157ba");
                        // Remove duplicates, if any.
                        x[key] = _.union(x[key]);
                    }
                }
                if (key !== 'topics' && key !== 'subtopics' && key !== 'sentiment') {
                    if (x[key].length !== 0) {
                        if (x[key][0] === 'selectAll') {
                            if (key !== 'location') {
                                switch (key) {
                                    case 'platform':
                                        if (platforms)
                                            temp = platforms.map(item => item.id);
                                        break;
                                    case 'influencers':
                                        if (influencers)
                                            temp = influencers.map(item => item.name)
                                        break;
                                    case 'themes':
                                        if (themes) {
                                            const view = sessionStorage.getItem("view") === "view1" ? "campaign" : "brand"
                                            temp = themes.filter(item => item.view === view).map(item => item.value)
                                            temp = temp.filter(t => t.indexOf("themeHeading") < 0)
                                        }
                                        break;
                                    case 'language':
                                        if (languages)
                                            temp = languages.map(item => item.id)
                                        break;
                                    default:
                                        break;
                                }
                            } else if (key === 'location') {
                                if (countries)
                                    temp = countries.map(item => item.id);
                            }
                            temp = temp.filter(item => item !== 'selectAll');
                        } else {
                            temp = x[key];
                            if (key === 'themes') {
                                temp = temp.filter(t => t.indexOf("themeHeading") < 0)
                            }
                        }
                    } else {
                        if (key !== 'location') {
                            switch (key) {
                                case 'platform':
                                    if (platforms)
                                        temp = platforms.map(item => item.id);
                                    break;
                                case 'themes':
                                    if(widgetName!=="themes") break;
                                    const view = sessionStorage.getItem("view") === "view1"? "campaign": "brand"
                                    if(view) temp = themes.filter(item => item.view === view).map(item => item.value)
                                    temp = temp.filter(t => t.indexOf("themeHeading")<0)
                                    break;
                                default:
                                    break;
                            }
                        }
                        temp = temp.filter(item => item !== 'selectAll');
                    }
                    if (key === 'publications') params.publications = x['publications']
                    if (key === 'location') {
                        params.location_ids = temp;
                    } else if (key === 'platform') {
                        params.platform_ids = temp;
                    } else if (key === 'themes') {
                        params.theme_ids = temp;
                    } else if (key === 'influencers') {
                        params.influencer_types = temp;
                    } else if (key === 'language') {
                        params.langauge_ids = temp;
                    }
                }
            }
        }
    }

    if(Object.keys(group_info).length>0){
        params.group_info = [];
        Object.keys(group_info).forEach((g) => {
            if (group_info[g].length > 1)
                params.group_info.push({
                    group_name: g,
                    subtopic_ids: group_info[g],
                });
        });
    }

    if(widgetName==="themes" && params.theme_ids.length>0){
        params.theme_group_info = [];
        const theme_group_info={}
        params.theme_ids.forEach(t=>{
            let x = themes.find(th=>th.value===t)
            if(theme_group_info[x.theme_name]){
                theme_group_info[x.theme_name].theme_ids.push(t)
            }
            else{
                theme_group_info[x.theme_name] ={
                    group_name: x.theme_name,
                    theme_ids: [t],
                }
            }
        })
        params.theme_group_info = Object.values(theme_group_info)
    }

    if(!x.hasOwnProperty("location")) params.location_ids = countries.map(item => item.id);
    if(!x.hasOwnProperty("platform")) params.platform_ids = platforms.map(item => item.id);
    return params;
}

let getTopicComparisionParamsFromFilters = (filters, interval, orderBy, post_types, widgetName) => {
    const { topics, countries, platforms, influencers, themes, languages } = JSON.parse(localStorage.getItem('meta'));
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;

    let x = removeDeletedSavedTopicsSubTopics(filters);
    let temp = null;
    let params = {
        location_ids: [],
        platform_ids: [],
        topic_data: [],
        campaigns: [],
        langauge_ids: [],
        sentiments: [],
        entity_boolean: '',
        theme_ids: [],
        influencer_types: [],
        interval: interval,
        post_types: [],
    };

    let duration = filters.duration

    switch(duration){
        case '7':
            duration = '7d'
            break;
        case '1M':
            duration = '1m'
            break;
        case 'entire':
            duration = 'entire'
            break;
    }

    for (let key in x) {
        temp = []
        if (x.hasOwnProperty(key) && key !== "duration" && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === 'topics' && key !== 'subtopics') {
                if (x["topics"][0] === "ALL" || (x["subtopics"] && x["subtopics"].length === 0 && x["topics"] && x["topics"].length === 0)) {
                    
                } else {
                    let topicTree = getTopicsTree(topics);
                    topicTree.forEach((tpc) => {
                        let subtopicIds = tpc.subtopics.map((sbt) => sbt.subtopic_id);
                        if (x["topics"].includes(tpc.topic_id)) {
                            let obj = {
                                id: tpc.topic_id,
                                start_date : moment(tpc.campaign_start_date).format("YYYY-MM-DDTHH:mm:ss"),
                                end_date : moment(tpc.campaign_end_date).tz(user_timezone_name).format("YYYY-MM-DDTHH:mm:ss"),
                                duration: duration,
                                interval : interval,
                                type : "topic",
                            };
                            params.campaigns.push(obj);
                        }
                        // For subtopics
                        x["subtopics"].forEach((sbt) => {
                            if (subtopicIds.includes(sbt)) {
                                // Already exists
                                if (params.topic_data.find((item) => item.topic_id === tpc.topic_id)) {
                                    let temp = params.topic_data.find((item) => item.topic_id === tpc.topic_id);
                                    temp.subtopic_ids.push(sbt);
                                } else {
                                    let obj = {
                                        id: sbt,
                                        start_date : tpc.campaign_start_date,
                                        end_date : tpc.campaign_end_date,
                                        duration: duration,
                                        interval : interval,
                                        type : "subtopic",
                                    };
                                    params.campaigns.push(obj);
                                }
                            }
                        });
                    });
                }
            } else if (key === 'sentiment') {
                if (x['sentiment'][0] !== 'selectAll') {
                    params.sentiments = x['sentiment']
                }
                else params.sentiments = ['positive', 'negative', 'neutral']
            } else if (Array.isArray(x[key])) {
                // For retweets
                if (key === 'platform') {
                    if (post_types) params.post_types.push(0, 1, 3, 4);
                    if (x[key][0] === "selectAll") { if (post_types) params.post_types.push(2); }
                    else if (x[key].includes("twitter_retweets")) {
                        if (post_types) params.post_types.push(2);
                        // if (x[key].length === 1) params.post_types = [2];
                        x[key] = x[key].filter(item => item !== "twitter_retweets");
                        x[key].push("6ce32a97-a789-11e4-a34f-74867a1157ba");
                        // Remove duplicates, if any.
                        x[key] = _.union(x[key]);
                    }
                }
                if (key !== 'topics' && key !== 'subtopics' && key !== 'sentiment') {
                    if (x[key].length !== 0) {
                        if (x[key][0] === 'selectAll') {
                            if (key !== 'location') {
                                switch (key) {
                                    case 'platform':
                                        if (platforms)
                                            temp = platforms.map(item => item.id);
                                        break;
                                    case 'influencers':
                                        if (influencers)
                                            temp = influencers.map(item => item.name)
                                        break;
                                    case 'themes':
                                        if (themes) {
                                            const view = sessionStorage.getItem("view") === "view1" ? "campaign" : "brand"
                                            temp = themes.filter(item => item.view === view).map(item => item.value)
                                            temp = temp.filter(t => t.indexOf("themeHeading") < 0)
                                        }
                                        break;
                                    case 'language':
                                        if (languages)
                                            temp = languages.map(item => item.id)
                                        break;
                                    default:
                                        break;
                                }
                            } else if (key === 'location') {
                                if (countries)
                                    temp = countries.map(item => item.id);
                            }
                            temp = temp.filter(item => item !== 'selectAll');
                        } else {
                            temp = x[key];
                            if (key === 'themes') {
                                temp = temp.filter(t => t.indexOf("themeHeading") < 0)
                            }
                        }
                    } else {
                        if (key !== 'location') {
                            switch (key) {
                                case 'platform':
                                    if (platforms)
                                        temp = platforms.map(item => item.id);
                                    break;
                                case 'themes':
                                    if(widgetName!=="themes") break;
                                    const view = sessionStorage.getItem("view") === "view1"? "campaign": "brand"
                                    if(view) temp = themes.filter(item => item.view === view).map(item => item.value)
                                    temp = temp.filter(t => t.indexOf("themeHeading")<0)
                                    break;
                                default:
                                    break;
                            }
                        }
                        temp = temp.filter(item => item !== 'selectAll');
                    }
                    if (key === 'publications') params.publications = x['publications']
                    if (key === 'location') {
                        params.location_ids = temp;
                    } else if (key === 'platform') {
                        params.platform_ids = temp;
                    } else if (key === 'themes') {
                        params.theme_ids = temp;
                    } else if (key === 'influencers') {
                        params.influencer_types = temp;
                    } else if (key === 'language') {
                        params.langauge_ids = temp;
                    }
                }
            }
        }
    }
    if(!x.hasOwnProperty("location")) params.location_ids = countries.map(item => item.id);
    if(!x.hasOwnProperty("platform")) params.platform_ids = platforms.map(item => item.id);
    return params;
}

let getSK2TopicPerformanceParams = (filters, interval, orderBy, passed_post_types) => {
    const { topics, countries, platforms, influencers, themes, languages } = JSON.parse(localStorage.getItem('meta'));
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;

    let x = removeDeletedSavedTopicsSubTopics(filters);
    let temp = null;
    let params = {
        start_date: null,
        end_date: null,
        location_ids: [],
        platform_ids: [],
        topic_data: [],
        competitor_topic_data: [],
        langauge_ids: [],
        sentiments: [],
        entity_boolean: '',
        theme_ids: [],
        orderBy: orderBy ? orderBy : 'post.published_date',
        influencer_types: [],
        interval: interval,
        enable_compare: 1,
        post_types: [],
        groupBy: 'topic'
    };

    if(filters.should_location_language_search_with_or) params.should_location_language_search_with_or = true

    let group_info = {}

    // Logic to get duration
    let today = moment.utc().tz(user_timezone_name);
    let start_date = moment.utc().tz(user_timezone_name);

    switch (x.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(x.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(x.end_date)
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd');
            break
    }

    if (x.duration === "7" || x.duration === "1M" || x.duration === "3M" || x.duration === "6M" || x.duration === "12M") {
        params.start_date = moment(start_date).format("YYYY-MM-DDT00:00:00");
        params.end_date = moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        params.start_date = moment(start_date).format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    // Subtopic/Topic Grouping
    if (x['subtopics'] && x['subtopics'].length > 0) {
        params.groupBy = 'subtopic';
    }

    for (let key in x) {
        temp = []
        if (x.hasOwnProperty(key) && key !== "duration" && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === 'topics' && key !== 'subtopics') {
                if (x['subtopics'] && x['subtopics'].length === 0 && x['topics'] && x['topics'].length === 0) {
                    // If no topic/subtopic is selected, send all.
                    // let topicTree = getTopicsTree(topics);
                    // topicTree.forEach(tpc => {
                    //     if (tpc.topic_name.includes('SKII')) {
                    //         let obj = {
                    //             topic_id: tpc.topic_id,
                    //             subtopic_ids: tpc.subtopics.map(sbt => sbt.subtopic_id)
                    //         }
                    //         params.topic_data.push(obj);
                    //     } else {
                    //         let obj = {
                    //             topic_id: tpc.topic_id,
                    //             subtopic_ids: tpc.subtopics.map(sbt => sbt.subtopic_id)
                    //         }
                    //         params.competitor_topic_data.push(obj);
                    //     }
                    // })
                } else if (x['topics'][0] === 'ALL') {
                    let topicTree = getTopicsTree(topics);
                    topicTree.forEach(tpc => {
                        let obj = {
                            topic_id: tpc.topic_id,
                            subtopic_ids: tpc.subtopics.map(sbt => sbt.subtopic_id)
                        }
                        params.topic_data.push(obj);
                    })
                }
                else {
                    let topicTree = getTopicsTree(topics);
                    topicTree.forEach(tpc => {
                        let subtopicIds = tpc.subtopics.map(sbt => sbt.subtopic_id);
                        if (x['topics'].includes(tpc.topic_id)) {
                            if (tpc.topic_name.includes('SKII')) {
                                let obj = {
                                    topic_id: tpc.topic_id,
                                    subtopic_ids: tpc.subtopics.map(sbt => sbt.subtopic_id)
                                }
                                params.topic_data.push(obj);
                            } else {
                                let obj = {
                                    topic_id: tpc.topic_id,
                                    subtopic_ids: tpc.subtopics.map(sbt => sbt.subtopic_id)
                                }
                                params.competitor_topic_data.push(obj);
                            }
                        }
                        // For subtopics
                        x['subtopics'].forEach(sbt => {
                            if (subtopicIds.includes(sbt)) {
                                // Already exists
                                if (params.topic_data.find(item => item.topic_id === tpc.topic_id)) {
                                    let temp = params.topic_data.find(item => item.topic_id === tpc.topic_id);
                                    temp.subtopic_ids.push(sbt);
                                } else if (params.competitor_topic_data.find(item => item.topic_id === tpc.topic_id)) {
                                    let temp = params.competitor_topic_data.find(item => item.topic_id === tpc.topic_id);
                                    temp.subtopic_ids.push(sbt);
                                } else {
                                    if (tpc.topic_name.includes('SKII')) {
                                        let obj = {
                                            topic_id: tpc.topic_id,
                                            subtopic_ids: [sbt]
                                        }
                                        params.topic_data.push(obj);
                                    } else {
                                        let obj = {
                                            topic_id: tpc.topic_id,
                                            subtopic_ids: [sbt]
                                        }
                                        params.competitor_topic_data.push(obj);
                                    }
                                }
                                let subTopicData = tpc.subtopics.filter(s=>s.subtopic_id===sbt)
                                if(subTopicData && subTopicData.length && subTopicData[0].subtopic_group_name){
                                    if (!group_info[subTopicData[0].subtopic_group_name]) group_info[subTopicData[0].subtopic_group_name] = [sbt];
                                    else group_info[subTopicData[0].subtopic_group_name].push(sbt);
                                }
                            }
                        })
                    })
                }
            } else if (key === 'sentiment') {
                if (x['sentiment'][0] !== 'selectAll') {
                    params.sentiments = x['sentiment']
                }
                else params.sentiments = ['positive', 'negative', 'neutral']
            } else if (Array.isArray(x[key])) {
                if (key !== 'topics' && key !== 'subtopics' && key !== 'sentiment') {
                    if (x[key].length !== 0) {
                        if (x[key][0] === 'selectAll') {
                            if (key !== 'location') {
                                switch (key) {
                                    case 'platform':
                                        if (platforms)
                                            temp = platforms.map(item => item.id);
                                        break;
                                    case 'influencers':
                                        if (influencers)
                                            temp = influencers.map(item => item.name)
                                        break;
                                    case 'themes':
                                        if (themes) {
                                            const view = sessionStorage.getItem("view") === "view1" ? "campaign" : "brand"
                                            temp = themes.filter(item => item.view === view).map(item => item.value)
                                            temp = temp.filter(t => t.indexOf("themeHeading") < 0)
                                        }
                                        break;
                                    case 'language':
                                        if (languages)
                                            temp = languages.map(item => item.id)
                                        break;
                                    default:
                                        break;
                                }
                            } else if (key === 'location') {
                                if (countries)
                                    temp = countries.map(item => item.id);
                            }
                            temp = temp.filter(item => item !== 'selectAll');
                        } else {
                            temp = x[key];
                        }
                    } else {
                        if (key !== 'location') {
                            switch (key) {
                                case 'platform':
                                    if (platforms)
                                        temp = platforms.map(item => item.id);
                                    break;
                                default:
                                    break;
                            }
                        } else if (key === 'location') {
                            temp = countries.map(item => item.id);
                        }
                        temp = temp.filter(item => item !== 'selectAll');
                    }
                    if (key === 'publications') params.publications = x['publications']
                    if (key === 'location') {
                        params.location_ids = temp;
                    } else if (key === 'platform') {
                        params.platform_ids = temp;
                    } else if (key === 'themes') {
                        params.theme_ids = temp;
                    } else if (key === 'influencers') {
                        params.influencer_types = temp;
                    } else if (key === 'language') {
                        params.langauge_ids = temp;
                    }
                }
            }
        }
    }

    if(Object.keys(group_info).length>0){
        params.group_info = [];
        Object.keys(group_info).forEach((g) => {
            if (group_info[g].length > 1)
                params.group_info.push({
                    group_name: g,
                    subtopic_ids: group_info[g],
                });
        });
    }

    if(!x.hasOwnProperty("location")) params.location_ids = countries.map(item => item.id);
    if(!x.hasOwnProperty("platform")) params.platform_ids = platforms.map(item => item.id);
    return params;
}

// Convert filter JSON to URLSearchParams
let getSK2TopicDataParamsFromFilters = (filters, aggs_interval) => {
    const { topics,countries, platforms, languages } = JSON.parse(localStorage.getItem('meta'));
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });

    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }

    let x = removeDeletedSavedTopicsSubTopics(filters);
    let temp = '';
    let params = new URLSearchParams();

    params.append('data', 1);
    params.append('order', 'desc');
    params.append('orderBy', 'post.published_date');
    params.append('aggs-interval', aggs_interval ? aggs_interval : 'day');

    let today = moment.utc().tz(user_timezone_name);
    let start_date = moment.utc().tz(user_timezone_name);

    switch (x.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h').format('YYYY-MM-DDTHH:mm:ss');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 }).format('YYYY-MM-DDTHH:mm:ss');
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(x.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(filters.end_date)
            break;
        case "entire":
            start_date = moment(campaign?.campaign_start_date);
            today = (moment(campaign?.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign?.campaign_end_date);
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd').format('YYYY-MM-DDTHH:mm:ss');
            break
    }

    if (x.duration === "7" || x.duration === "1M" || x.duration === "3M" || x.duration === "6M" || x.duration === "12M") {
        params.append("start_date", moment(start_date).format("YYYY-MM-DDT00:00:00"));
        params.append("end_date", moment(today).format("YYYY-MM-DDT23:59:59"));
    } else {
        params.append("start_date", moment(start_date).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("end_date", moment(today).format("YYYY-MM-DDTHH:mm:ss"));
    }

    // Subtopic/Topic Grouping
    if (x['subtopics'] && x['subtopics'].length > 0) {
        params.append('groupBy','subtopic');
    }

    let group_info_param = [];

    for (let key in x) {
        if (x.hasOwnProperty(key) && key !== 'duration' && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === 'topics' && key !== 'subtopics') {
                const {topicsData, group_info} = formatTopicsSubtopics(x)
                params.append('topic_data', JSON.stringify(topicsData))

                if(Object.keys(group_info).length>0){
                    Object.keys(group_info).forEach((g) => {
                        if (group_info[g].subtopics.length > 1)
                            group_info_param.push({
                                group_name: g,
                                topic_id: group_info[g].topic_id,
                                subtopic_ids: group_info[g].subtopics,
                            });
                    });
                    params.append('group_info', JSON.stringify(group_info_param))
                }
            } else if (key === 'sentiment') {
                if (x['sentiment'][0] !== 'selectAll') {
                    params.append('sentiment', x['sentiment'].join(','))
                }
            } else if (Array.isArray(x[key])) {
                if (key !== 'topics' && key !== 'subtopics' && key !== 'sentiment' && x[key].length !== 0) {
                    if (x[key][0] === 'selectAll') {
                        if (key === 'location' && countries) {
                            temp = countries.map(item => item.id);
                        }
                        if (key === 'platform' && platforms) {
                            temp = platforms.map(item => item.id);
                        }
                        if (key === 'language' && languages) {
                            temp = languages.map(item => item.id);
                        }
                        if (typeof temp !== "string" && temp.length > 0) {
                            temp = temp.filter(item => item !== 'selectAll');
                            temp = temp.join(',');
                        }
                    } else {
                        temp = x[key].join(',');
                    }
                    params.append(key, temp)
                }
            } else if (!Array.isArray(x[key])) {
                if (key !== 'topics' && key !== 'subtopics' && x[key] !== 'all') {
                    if (key !== 'entity_sub_type' && key !== 'entity_type') {
                        params.append(key, x[key]);
                    }
                }
            }
        }
    }
    if(!x.hasOwnProperty("location")) params.append("location",countries.map(item => item.id));
    if(!x.hasOwnProperty("platform")) params.append("platform",platforms.map(item => item.id));
    return { params, group_info : group_info_param };
}

// Convert filter JSON to URLSearchParams
let getTopicDataParamsFromFilters = (filters, aggs_interval) => {
    const { topics, countries, platforms, languages } = JSON.parse(localStorage.getItem('meta'));
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });

    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }

    let x = filters;
    let temp = '';
    let params = new URLSearchParams();

    params.append('data', 1);
    params.append('order', 'desc');
    params.append('orderBy', 'post.published_date');
    params.append('aggs-interval', aggs_interval ? aggs_interval : 'day');

    let today = moment.utc().tz(user_timezone_name);
    let start_date = moment.utc().tz(user_timezone_name);
    switch (x.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h').format('YYYY-MM-DDTHH:mm:ss');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 }).format('YYYY-MM-DDTHH:mm:ss');
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(x.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(x.end_date)
            break;
        case "entire":
            start_date = moment(campaign?.campaign_start_date);
            today = (moment(campaign?.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign?.campaign_end_date);
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd').format('YYYY-MM-DDTHH:mm:ss');
            break
    }

    if (x.duration === "7" || x.duration === "1M" || x.duration === "3M" || x.duration === "6M" || x.duration === "12M") {
        params.append("start_date", moment(start_date).format("YYYY-MM-DDT00:00:00"));
        params.append("end_date", moment(today).format("YYYY-MM-DDT23:59:59"));
    } else {
        params.append("start_date", moment(start_date).format("YYYY-MM-DDTHH:mm:ss"));
        params.append("end_date", moment(today).format("YYYY-MM-DDTHH:mm:ss"));
    }

    for (let key in x) {
        if (x.hasOwnProperty(key) && key !== 'duration' && key !== "start_date" && key !== "end_date" && key !== "rollingDate") {
            if (key === 'topics' && key !== 'subtopics') {
                const {topicsData} = formatTopicsSubtopics(x)
                params.append('topic_data', JSON.stringify(topicsData))
            } else if (key === 'sentiment') {
                if (x['sentiment'][0] !== 'selectAll') {
                    params.append('sentiment', x['sentiment'].join(','))
                }
            } else if (Array.isArray(x[key])) {
                if (key !== 'topics' && key !== 'subtopics' && key !== 'sentiment' && x[key].length !== 0) {
                    if (x[key][0] === 'selectAll') {
                        if (key === 'location' && countries) {
                            temp = countries.map(item => item.id);
                        }
                        if (key === 'platform' && platforms) {
                            temp = platforms.map(item => item.id);
                        }
                        if (key === 'language' && languages) {
                            temp = languages.map(item => item.id);
                        }
                        if (typeof temp !== "string" && temp.length > 0) {
                            temp = temp.filter(item => item !== 'selectAll');
                            temp = temp.join(',');
                        }
                    } else {
                        temp = x[key].join(',');
                    }
                    params.append(key, temp)
                }
            } else if (!Array.isArray(x[key])) {
                if (key !== 'topics' && key !== 'subtopics' && x[key] !== 'all') {
                    if (key !== 'entity_sub_type' && key !== 'entity_type') {
                        params.append(key, x[key]);
                    }
                }
            }
        }
    }
    if(!x.hasOwnProperty("location")) params.append("location",countries.map(item => item.id));
    if(!x.hasOwnProperty("platform")) params.append("platform",platforms.map(item => item.id));
    return params;
}

let getTopicDetails = (subtopicId, allTopics) => {
    return allTopics.find(tp => tp.subtopic_id === subtopicId)
}

let formatTopicsSubtopics = (filter, subtopicsChecked = true) => {

    let allTopics = JSON.parse(localStorage.getItem('meta')).topics
    let topicsData = []

    let selectedTopics = filter.topics
    let selectedSubtopics = filter.subtopics
    if ((selectedTopics.length === 0 && selectedSubtopics.length === 0) || (selectedTopics.length === 0 && subtopicsChecked === false) || (selectedTopics.length === 1 && selectedTopics[0] === 'ALL') || (selectedSubtopics.length === 1 && selectedSubtopics[0] === 'ALL')) {
        //select all topics
        // if (sessionStorage.getItem("view") === "view1") {
        //     const allTopicIds = allTopics.map((tpc) => tpc.view_name && tpc.view_name === "campaign" && tpc.topic_id);
        //     selectedTopics = getDynamicTopics({
        //         duration: filter.duration,
        //         start_date: filter.start_date,
        //         end_date: filter.end_date,
        //         rollingDate: filter.rollingDate,
        //         topics: allTopicIds,
        //         subtopics: [],
        //     }).topics;
        // } else {
        //     selectedTopics = allTopics.map((tpc) => tpc.topic_id);
        // }
        selectedTopics = [];
        subtopicsChecked = false
    }
    let group_info = {};
    if (subtopicsChecked) {
        filter.subtopics.forEach(subtopic => {
            let subtopicDetails = getTopicDetails(subtopic, allTopics);
            if (subtopicDetails !== undefined) {
                if (subtopicDetails.subtopic_group_name) {
                    if (!group_info[subtopicDetails.subtopic_group_name])
                        group_info[subtopicDetails.subtopic_group_name] = { subtopics: [subtopic], topic_id: subtopicDetails.topic_id };
                    else group_info[subtopicDetails.subtopic_group_name].subtopics.push(subtopic);
                }
                let ind = topicsData.findIndex(d => d.topic_id == subtopicDetails.topic_id)
                if (ind === -1) {
                    topicsData.push({
                        topic_id: subtopicDetails.topic_id,
                        name: subtopicDetails.topic_name,
                        subtopicIds: [subtopic],
                        subtopicNames: [{
                            id: subtopic,
                            name: subtopicDetails.subtopic_name
                        }]
                    })
                } else {
                    topicsData[ind].subtopicIds.push(subtopic)
                    topicsData[ind].subtopicNames.push({
                        id: subtopic,
                        name: subtopicDetails.subtopic_name
                    })
                }
            }
        }, this);
    }

    selectedTopics.forEach(topic => {
        let subtopics = allTopics
        let subtopicsList = subtopics.filter(tpc => tpc.topic_id === topic)
        if (subtopicsList.length > 0)
            topicsData.push({
                topic_id: topic,
                name: subtopicsList[0].topic_name,
                subtopicIds: subtopicsList.map(x => x.subtopic_id),
                subtopicNames: subtopicsList.map(x => {
                    return {
                        id: x.subtopic_id,
                        name: x.subtopic_name
                    }
                })
            })
    })

    return { topicsData, group_info }
}

// For given filters get the duration and selected shuffle parameter
let getComponentDurationAndSubtitleForSK2 = (filters) => {
    let { topics } = JSON.parse(localStorage.getItem('meta'));
    let ids_to_find = filters['topics']
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;

    let obj = {
        duration: '',
        subtitle: [],
        subtitlehover: []
    }
    let subtitlehover = {}
    // Logic to get the subtitle
    let c = 0;
    ids_to_find.forEach((tpc, index) => {
        if (topics.find((item) => item.topic_id == tpc)) {
            const subtitle = topics.find((item) => item.topic_id === tpc) ? topics.find((item) => item.topic_id === tpc).topic_name : "";
            obj.subtitle.push(subtitle);
            c++;
            if (c > 21) return;
            subtitlehover[subtitle] = [];
        }
    });

    filters["subtopics"].forEach((sbt, index) => {
        if (topics.find((item) => item.subtopic_id == sbt)) {
            const subtopic = topics.find((item) => item.subtopic_id === sbt);
            obj.subtitle.push(subtopic ? subtopic.topic_name : "");
            c++;
            if (c > 21) return;
            if (subtopic) {
                if (!subtitlehover[subtopic.topic_name]) subtitlehover[subtopic.topic_name] = [subtopic.subtopic_name];
                else subtitlehover[subtopic.topic_name].push(subtopic.subtopic_name);
            }
        }
    });

    for(let key of Object.keys(subtitlehover)){
        const t = key 
        const w = subtitlehover[key].length > 0 ? " (" + subtitlehover[key].join(", ") + ")" : ""
        obj.subtitlehover.push(t+w);
    }

    obj.subtitle = _.uniq(obj.subtitle);
    obj.subtitle = obj.subtitle.sort().join(",");
    obj.subtitlehover = obj.subtitlehover.sort().join(", ");
    if (c > 21) obj.subtitlehover += ". Click filters to view all selected topics and subtopics";
    let campaign, campaign_start_date, campaign_end_date;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });
    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }
    
    // console.log('filters2',filters)
    // console.log('campaign2',campaign)
    // campaign_start_date = moment(campaign.campaign_start_date)._d;
    // campaign_end_date = moment(campaign.campaign_end_date)._d;

    // Logic to get duration
    let today = new Date();
    let start_date = new Date();

    switch (filters.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(filters.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(filters.end_date)
            break;
        case "entire":
            if(campaign) start_date = moment(campaign?.campaign_start_date).tz(user_timezone_name);
            if(campaign) today = (moment(campaign?.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign?.campaign_end_date).tz(user_timezone_name);
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd');
            break
    }

    if (filters.duration === "7" || filters.duration === "1M" || filters.duration === "3M" || filters.duration === "6M" || filters.duration === "12M") {
        start_date = moment(start_date).format("YYYY-MM-DDT00:00:00");
        today = moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        start_date = moment(start_date).format("YYYY-MM-DDTHH:mm:ss");
        today = moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    if (moment(start_date).month() === moment(today).month() && moment(start_date).date() === moment(today).date()) {
        obj.duration = `${moment(today).format('DD MMM').toUpperCase()}`
    } else {
        obj.duration = `${moment(start_date).format('DD MMM').toUpperCase()} - ${moment(today).format('DD MMM').toUpperCase()}`
    }

    if (moment(start_date).month() === moment(today).month() && moment(start_date).date() !== moment(today).date()) {
        obj.duration = `${moment(start_date).format('DD').toUpperCase()} - ${moment(today).format('DD MMM').toUpperCase()}`
    }
    if (moment(start_date).year() !== moment(today).year()) {
        obj.duration = `${moment(start_date).format('DD MMM YY').toUpperCase()} - ${moment(today).format('DD MMM YY').toUpperCase()}`
    }
    return obj;
}

// For given filters get the duration and selected shuffle parameter
let getComponentDurationAndSubtitle = (filters, param, currentIndex) => {
    let { topics, countries } = JSON.parse(localStorage.getItem('meta'));
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let campaign;
    filters.topics.forEach((d) => {
        campaign = topics.find((t) => t.topic_id == d);
    });

    if(filters.subtopics) {
        filters.subtopics.forEach((d) => {
            campaign = topics.find((t) => t.subtopic_id == d);
        });
    }

    let obj = {
        duration: '',
        subtitle: ''
    }
    if (currentIndex !== undefined) {
        let id_to_find = filters[param] && filters[param][currentIndex];
        // Logic to get the subtitle
        if (id_to_find === 'ALL' || id_to_find === 'selectAll') {
            obj.subtitle = 'ALL';
        } else {
            if (param === 'topics') {
                obj.subtitle = topics.find(tpc => tpc.topic_id === id_to_find) ? topics.find(tpc => tpc.topic_id === id_to_find).topic_name : '';
            } else if (param === 'location') {
                obj.subtitle = countries.find(country => country.id === id_to_find) ? countries.find(country => country.id === id_to_find).name : '';
            }
        }
    }

    // Logic to get duration
    let today = new Date();
    let start_date = new Date();

    switch (filters.duration) {
        case '24HRS':
            start_date = moment(start_date).subtract(24, 'h');
            break;
        case '1':
            start_date = moment(start_date).set({ h: 0, m: 0, s: 0, ms: 0 });
            break;
        case '1M': 
            start_date = moment(start_date).subtract(30 - 1, 'd');
            break;
        case '3M': 
            start_date = moment(start_date).subtract(90 - 1, 'd');
            break;  
        case '6M': 
            start_date = moment(start_date).subtract(180 - 1, 'd');
            break;  
        case '12M': 
            start_date = moment(start_date).subtract(360 - 1, 'd');
            break;
        case "custom":
            start_date = moment(filters.start_date)
            today = filters.rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(filters.end_date)
            break;
        case "entire":
            start_date = moment(campaign?.campaign_start_date);
            today = (moment(campaign?.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign?.campaign_end_date);
            break;
        case '7':
        default:
            start_date = moment(start_date).subtract(filters.duration - 1, 'd');
            break
    }

    if (filters.duration === "7" || filters.duration === "1M" || filters.duration === "3M" || filters.duration === "6M" || filters.duration === "12M") {
        start_date = moment(start_date).format("YYYY-MM-DDT00:00:00");
        today = moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        start_date = moment(start_date).format("YYYY-MM-DDTHH:mm:ss");
        today = moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    if (moment(start_date).date() === moment(today).date()) {
        obj.duration = `${moment(today).format('DD MMM').toUpperCase()}`
    } else {
        obj.duration = `${moment(start_date).format('DD MMM').toUpperCase()} - ${moment(today).format('DD MMM').toUpperCase()}`
    }

    if (moment(start_date).month() === moment(today).month() && moment(start_date).date() !== moment(today).date()) {
        obj.duration = `${moment(start_date).format('DD').toUpperCase()} - ${moment(today).format('DD MMM').toUpperCase()}`
    }

    return obj;
}

let getFilterJson = (filter_json, filtersTobeRendered) => {
    const filter_json_modified = {};
    if (filtersTobeRendered.indexOf("sentiment") > -1) {
        filter_json_modified.sentiment = filter_json.sentiment;
    }
    if (filtersTobeRendered.indexOf("duration") > -1) {
        filter_json_modified.duration = filter_json.duration;
        if (filter_json.duration === "custom") {
            if (filter_json.hasOwnProperty("start_date")) filter_json_modified.start_date = filter_json.start_date;
            if (filter_json.hasOwnProperty("end_date")) filter_json_modified.end_date = filter_json.end_date;
            if (filter_json.hasOwnProperty("rollingDate") && filter_json.rollingDate) filter_json_modified.rollingDate = filter_json.rollingDate;
        }
    }
    if (filtersTobeRendered.indexOf("entity") > -1) {
        filter_json_modified.entity_type = filter_json.entity_type;
        filter_json_modified.entity_sub_type = filter_json.entity_sub_type;
    }
    if (filtersTobeRendered.indexOf("topics") > -1) {
        filter_json_modified.topics = filter_json.topics;
        filter_json_modified.subtopics = filter_json.subtopics;
    }
    if (filtersTobeRendered.indexOf("countries") > -1) {
        filter_json_modified.location = filter_json.location;
    }
    if (filtersTobeRendered.indexOf("languages") > -1) {
        filter_json_modified.language = filter_json.language;
    }
    if (filtersTobeRendered.indexOf("platforms") > -1) {
        filter_json_modified.platform = filter_json.platform;
    }
    if (filtersTobeRendered.indexOf("themes") > -1) {
        filter_json_modified.themes = filter_json.themes.filter(t => t.indexOf('themeHeading') < 0);
    }
    if (filtersTobeRendered.indexOf("publications") > -1) {
        filter_json_modified.publications = filter_json.publications;
    }
    if (filtersTobeRendered.indexOf("influencers") > -1) {
        filter_json_modified.influencers = filter_json.influencers;
    }
    if (filtersTobeRendered.indexOf("collections") > -1) {
        filter_json_modified.synced_collection_id = filter_json.synced_collection_id;
    }
    return filter_json_modified
}

export const getEndDate = (duration, duration_end_date, rollingDate, campaign) => {
    const user_timezone_name = JSON.parse(localStorage.getItem('meta')).company.user_timezone_name;
    let today = moment.utc().tz(user_timezone_name);
    let end_date;
    switch (duration) {
        case "custom":
            today = rollingDate ? moment().subtract(1, 'd').format('YYYY-MM-DDT23:59:59') : moment(duration_end_date)
            break;
        case "entire":
            today = campaign ? (moment(campaign?.campaign_end_date) > moment.utc().tz(user_timezone_name)) ? moment.utc().tz(user_timezone_name) : moment(campaign?.campaign_end_date).tz(user_timezone_name) : today;
            break;
        default:
            break;
    }

    if (duration === "7" || duration === "1M" || duration === "3M" || duration === "6M" || duration === "12M") {
        end_date = moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        end_date = moment(today).format("YYYY-MM-DDTHH:mm:ss");
    }

    return end_date
}

export const getInterval = (start_date, end_date, int, next_start_date) => {
    let intervalEndDate;
    switch (int) {
        case "day":
            intervalEndDate = moment(start_date).add(24, "h");
            break;
        case "hour":
            intervalEndDate = moment(start_date).add(60, "m");
            break;
        case "month":
            intervalEndDate = next_start_date ? moment(next_start_date) : moment(start_date).add(1, "M");
            break;
        case "week":
            intervalEndDate = moment(start_date).add(7, "d");
            break;
        default:
            break;
    }
    let interval = moment(start_date).format("llll") + " - " + (moment(intervalEndDate).isAfter(moment(end_date)) ? moment(end_date).format('llll') : moment(intervalEndDate).subtract(1,'s').format("llll"))
    return interval
}

export const getOnClickDateParams = (start_date, duration_end, interval, next_start_date) => {
    if(!moment(next_start_date).isValid()) next_start_date = duration_end
    let end_date;
    switch (interval) {
        case "day":
            end_date = moment(start_date).add(24, "h");
            break;
        case "hour":
            end_date = moment(start_date).add(60, "m");
            break;
        case "month":
            end_date = next_start_date ? moment(next_start_date) : moment(start_date).add(1, "M");
            break;
        case "week":
            end_date = moment(start_date).add(7, "d");
            break;
        case "year":
            end_date = moment(start_date).add(365, "d");
            break;
        default:
            break;
    }
    end_date = moment(end_date).isAfter(moment(duration_end)) ? moment(duration_end) : moment(end_date).subtract(1,'s')
    return end_date
}

// function to remove all the topics and subtopics that are saved in the db for the widget but aren't active in current topic list.
export const removeDeletedSavedTopicsSubTopics = (filters) => {
    const { topics } = JSON.parse(localStorage.getItem("meta"));

    let savedtopics = [],
        savedsubtopics = [];

    savedtopics = filters.topics.filter((t) => topics.find((tp) => tp.topic_id == t));
    savedsubtopics = filters.subtopics.filter((t) => topics.find((tp) => tp.subtopic_id == t));

    return { ...filters, topics: savedtopics, subtopics: savedsubtopics };
}

export {
    getParamsFromFilters,
    getPostFeedParamsFromFilters,
    getSK2ParamsFromFilters,
    getSK2PostContainerParams,
    getSK2TopicPerformanceParams,
    getSK2TopicDataParamsFromFilters,
    getTopicDataParamsFromFilters,
    formatCountrySentimentsBreakup,
    getComponentDurationAndSubtitle,
    getComponentDurationAndSubtitleForSK2,
    getTopicComparisionParamsFromFilters,
    formatVOCData,
    formatTimeSeriesMentions,
    getFilterJson,
    getDynamicTopics,
    getDynamicThemes
} 